import React from "react";
import { mergeStyles, Text } from "office-ui-fabric-react"
import OrderDetailTxt from "./forms/edditOrder/OrderDetailTxt";
import OrderDetailLink from "./forms/edditOrder/OrderDetailLink";
import { RootStateOrAny, useSelector } from "react-redux";
import { Reason } from "../../common/enums/reason.enum";
import { getReasonsById } from "../../../connectors/cancellationReasons/connectors";
import { useQuery } from "react-query";
import { OrderTypeNumber } from "../../common/enums/orderTypes.enum";
import {
  cuoSectionContainer,
  cuoSectionTitle,
  cuoSubsectionTitle,
  cuoGridTwoColumns,
  cuoGridThreeColumns,
  cuoSubsection
} from "../styles/detailTxt.style";

const wrapper = mergeStyles({
  padding: 20
})

const decodeHtmlEntities = (text: string): string => {
  const textarea = document.createElement('textarea');
  textarea.innerHTML = text;
  return textarea.value;
};

const OrderDetails: React.FC = () => {
  const { orderDetails } = useSelector((state: RootStateOrAny) => state.orderPanel)
  const { data } = useQuery(
    ["reasonForCancellation", Reason.OrderCancel],
    getReasonsById
  );
  let cancelReason = undefined;
  if (data) {
    for (let reason of data.data.data) {
      if (reason.id === orderDetails.reasonForCancellation) {
        cancelReason = reason.value
      }
    }
  }

  return (
    <div className={wrapper}>
      {orderDetails && (
        <div>
          <OrderDetailTxt
            title="Numer zamówienia"
            value={orderDetails.orderInfo.number}
          />
          <OrderDetailTxt
            title="Nazwa klienta"
            value={orderDetails.orderInfo.company}
          />
          <OrderDetailTxt
            title="Adres odbioru"
            value={orderDetails.orderInfo.receptionPlace}
          />
          <OrderDetailTxt
            title="Numer kontaktowy"
            value={orderDetails.orderInfo.receptionPlacePhone}
          />
          <OrderDetailTxt
            title="Typ zamówienia"
            value={orderDetails.orderInfo.type}
          />
          <OrderDetailTxt
            title="Pojazd"
            value={orderDetails.orderInfo.vehicle ? orderDetails.orderInfo.vehicle : "Brak"}
          />
          <OrderDetailTxt
            title="Dodatkowe Informacje"
            value={orderDetails.additionalInfo ? orderDetails.additionalInfo : "Brak"}
          />
          <OrderDetailTxt
            title="Forma Płatności"
            value={orderDetails.paymentType === 0 ? "Gotówka" : "Przelew"}
          />
          <OrderDetailTxt
            title="Ilość"
            value={orderDetails.orderInfo.quantity}
          />

          {orderDetails.cuoOrderDetails && orderDetails.tireQuantity && (
            <OrderDetailTxt
              title="Ilość opon"
              value={`${orderDetails.tireQuantity} szt.`}
            />
          )}





          {orderDetails.netPrice != null && orderDetails.netPrice > 0 && <OrderDetailTxt
            title={orderDetails.orderTypeId == OrderTypeNumber.Tonnage ? "Cena netto za jedną tonę" : "Cena netto"}
            value={(orderDetails.netPrice).toFixed(2).toString()}
          />}
          {orderDetails.grossPrice != null && orderDetails.grossPrice > 0 && <OrderDetailTxt
            title={orderDetails.orderTypeId == OrderTypeNumber.Tonnage ? "Cena brutto za jedną tonę" : "Cena brutto"}
            value={(orderDetails.grossPrice).toFixed(2).toString()}
          />}
          {orderDetails.orderTypeId != OrderTypeNumber.Tonnage ?
            <>
              {orderDetails.netValue != null && orderDetails.netValue > 0 &&
                <OrderDetailTxt
                  title="Wartość netto"
                  value={orderDetails.netValue.toFixed(2).toString()}
                />}
              {orderDetails.grossValue != null && orderDetails.grossValue > 0 &&
                <OrderDetailTxt
                  title="Wartość brutto"
                  value={(orderDetails.grossValue).toFixed(2).toString()}
                />}
            </> : <></>}
          {orderDetails.kpo && <OrderDetailTxt
            title="KPO"
            value={orderDetails.kpo}
          />}
          {orderDetails.tonnage && <OrderDetailTxt
            title="Tonaż"
            value={orderDetails.tonnage}
          />}
          {orderDetails.internalStoreName && <OrderDetailTxt
            title="Magazyn wewnętrzny"
            value={orderDetails.internalStoreName}
          />}
          {orderDetails.recycleOperatorName && <OrderDetailTxt
            title="Operator"
            value={orderDetails.recycleOperatorName}
          />}
          {orderDetails.optimaStatusName && orderDetails.recycleOperatorName && <OrderDetailTxt
            title="Status synchronizacji - Optima"
            value={orderDetails.optimaStatusName}
          />}
          {orderDetails.optimaNumber && <OrderDetailTxt
            title="Numer Optima"
            value={orderDetails.optimaNumber}
          />}
          {orderDetails.invoiceNumber && <OrderDetailTxt
            title="Numer faktury"
            value={orderDetails.invoiceNumber}
          />}
          {cancelReason ? <OrderDetailTxt
            title="Powód anulowania"
            value={cancelReason}
          /> : null}



          {orderDetails.cuoOrderDetails && (
            <div className={cuoSectionContainer}>
              <Text styles={cuoSectionTitle}>Szczegóły zamówienia CUO</Text>

              <div className={cuoGridTwoColumns}>
                <OrderDetailTxt
                  title="Numer zamówienia CUO"
                  value={orderDetails.cuoOrderDetails.cuoOrderNumber}
                />
                {orderDetails.cuoOrderDetails.cuoOrderDate && (
                  <OrderDetailTxt
                    title="Data zamówienia CUO"
                    value={new Date(orderDetails.cuoOrderDetails.cuoOrderDate).toLocaleDateString('pl-PL')}
                  />
                )}
              </div>

              <div className={cuoSubsection}>
                <Text styles={cuoSubsectionTitle}>Podsumowanie realizacji</Text>
                <div className={cuoGridTwoColumns}>
                  <OrderDetailTxt
                    title="Zamówione opony"
                    value={`${orderDetails.cuoOrderDetails.totalTiresOrdered} szt.`}
                  />
                  <OrderDetailTxt
                    title="Zrealizowane opony"
                    value={`${orderDetails.cuoOrderDetails.totalTiresRealized} szt.`}
                  />
                  <OrderDetailTxt
                    title="Zamówienia SODO"
                    value={`${orderDetails.cuoOrderDetails.totalSodoOrders} szt.`}
                  />
                  <OrderDetailTxt
                    title="Zrealizowane zamówienia"
                    value={`${orderDetails.cuoOrderDetails.realizedSodoOrders} szt.`}
                  />
                </div>
              </div>

              {orderDetails.cuoOrderDetails.positions && orderDetails.cuoOrderDetails.positions.length > 0 && (
                <div className={cuoSubsection}>
                  <Text styles={cuoSubsectionTitle}>Pozycje zamówienia</Text>
                  <div className={cuoGridThreeColumns}>
                    {orderDetails.cuoOrderDetails.positions.map((position: any, index: number) => {                     
                      const isSpecial = position.name && (
                        position.name.toLowerCase().includes('specjalne')
                      );
                      const displayValue = isSpecial
                        ? `Zamówione: ${position.quantity} szt.`
                        : `Zamówione: ${position.quantity} szt. | Zrealizowane: ${position.quantityRealized} szt.`;

                      return (
                        <div key={index}>
                          <OrderDetailTxt
                            title={position.name}
                            value={displayValue}
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}

              {orderDetails.cuoOrderDetails.description && (
                <div className={cuoSubsection}>
                  <OrderDetailTxt
                    title="Opis zamówienia"
                    value={decodeHtmlEntities(orderDetails.cuoOrderDetails.description)}
                  />
                </div>
              )}

              {(orderDetails.cuoOrderDetails.clientName || orderDetails.cuoOrderDetails.firmName ||
                orderDetails.cuoOrderDetails.address || orderDetails.cuoOrderDetails.phone) && (
                <div className={cuoSubsection}>
                  <Text styles={cuoSubsectionTitle}>Dane klienta</Text>
                  <div className={cuoGridTwoColumns}>
                    {orderDetails.cuoOrderDetails.clientName && (
                      <OrderDetailTxt
                        title="Klient CUO"
                        value={orderDetails.cuoOrderDetails.clientName}
                      />
                    )}
                    {orderDetails.cuoOrderDetails.firmName && (
                      <OrderDetailTxt
                        title="Zlecający Odbiór"
                        value={orderDetails.cuoOrderDetails.firmName}
                      />
                    )}

                    {orderDetails.cuoOrderDetails.address && (
                      <OrderDetailTxt
                        title="Adres CUO"
                        value={orderDetails.cuoOrderDetails.address}
                      />
                    )}
                    {orderDetails.cuoOrderDetails.phone && (
                      <OrderDetailTxt
                        title="Telefon CUO"
                        value={orderDetails.cuoOrderDetails.phone}
                      />
                    )}
                  </div>
                </div>
              )}
  
              {(orderDetails.cuoOrderDetails.regionName || orderDetails.cuoOrderDetails.operatorName ||
                orderDetails.cuoOrderDetails.pickupDate || orderDetails.cuoOrderDetails.statusName) && (
                <div className={cuoSubsection}>
                  <Text styles={cuoSubsectionTitle}>Informacje operacyjne</Text>
                  <div className={cuoGridTwoColumns}>
                    {orderDetails.cuoOrderDetails.regionName && (
                      <OrderDetailTxt
                        title="Region"
                        value={orderDetails.cuoOrderDetails.regionName}
                      />
                    )}
                    {orderDetails.cuoOrderDetails.operatorName && (
                      <OrderDetailTxt
                        title="Operator CUO"
                        value={orderDetails.cuoOrderDetails.operatorName}
                      />
                    )}
                    {orderDetails.cuoOrderDetails.pickupDate && (
                      <OrderDetailTxt
                        title="Data odbioru CUO"
                        value={new Date(orderDetails.cuoOrderDetails.pickupDate).toLocaleDateString('pl-PL')}
                      />
                    )}

                  </div>
                </div>
              )}

              <div className={cuoGridTwoColumns}>
                <OrderDetailTxt
                  title="Status raportu do CUO"
                  value={orderDetails.cuoDeliveryReportSent ? "Wysłano" : "Nie wysłano"}
                />
                {orderDetails.cuoDeliveryReportSentAt && (
                  <OrderDetailTxt
                    title="Data wysłania raportu"
                    value={new Date(orderDetails.cuoDeliveryReportSentAt).toLocaleString('pl-PL')}
                  />
                )}

                {orderDetails.cuoOrderDetails.cuoOrderId && (
                  <OrderDetailLink
                    title="Link do zamówienia w CUO"
                    url={`https://app.utylizacjaopon.pl/Order/View/${orderDetails.cuoOrderDetails.cuoOrderId}`}
                  />
                )}
              </div>
            </div>
          )}

        </div>
      )}
    </div>
  );
};

export default OrderDetails;